export class TokenResponse {
	AccessToken: string;
	RefreshToken: string;
}
